import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import axios from 'axios'
import i18n from './i18n'
import store from './store'
import { createGtm } from "vue-gtm"
import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3'
import vue3GoogleLogin from 'vue3-google-login'
import { InitApplication } from '@/helpers/app.js'
import { who, hscroll, scrollPercent, scrollto, helpTooltip } from '@/helpers/directives.js'

// PrimeVue
import PrimeVue from 'primevue/config'
import Lara from '@primeuix/themes/lara'
import Ripple from 'primevue/ripple'
import Tooltip from 'primevue/tooltip'
import { definePreset } from '@primeuix/themes'

// Vuetify
import './vuetify/variables.scss'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import theme from './vuetify/theme.js'
import './assets/main.css'

import 'remixicon/fonts/remixicon.css'

const component = {

    setup() {

		const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

		const recaptcha = async () => {

			await recaptchaLoaded()
			// Execute reCAPTCHA with action "login".
			await executeRecaptcha('login')
		}
  
		return { recaptcha }
    },

    template: ''
}

const vuetify = createVuetify({ components, directives, theme })

const app = createApp(App, component)

export const globalProperties = app.config.globalProperties
app.config.globalProperties.$store = store
app.config.globalProperties.$state = store.state

app.use(router, store, axios)
app.use(vuetify)
app.use(i18n)

const MyPreset = definePreset(Lara, {
    semantic: {
        third: {
            // 50: '#FDF3F9',
            50: '#FAE6F4',
            100: '#F4D1EA',
            200: '#EEB9DD',
            300: '#EAA4D2',
            400: '#E784C6',
            500: '#DC47A9',
            600: '#D0098D',
            700: '#B7077C',
            800: '#990669',
            900: '#5A043F',
            950: '#300223'
        },
		second: {
            // 50: '#F2F4F7',
            50: '#D9DDE7',
            100: '#D9DDE7',
            200: '#C6CCDA',
            300: '#C6CCDA',
            400: '#A0A9C0',
            500: '#8490AE',
            600: '#67769B',
            700: '#2B3B73',
            800: '#011956',
            900: '#001341',
            950: '#000A2B'
        },
		primary: {
            50: '#F4FAFC',
            100: '#E3F4F8',
            200: '#C7E7EE',
            300: '#A5D9E4',
            400: '#90CFDD',
            500: '#83C9D9',
            600: '#75C3D5',
            700: '#219EBC',
            800: '#0F6C86',
            900: '#064E66',
            950: '#004052'
        },
		colorScheme: {
			light: {
				primary: {
					color: '{primary.700}',      // antes: {zinc.950}
					inverseColor: '#ffffff',
					hoverColor: '{primary.900}', // antes: {zinc.900}
					activeColor: '{primary.950}' // antes: {zinc.800}
				},
				highlight: {
					background: '{primary.300}',
					focusBackground: '{primary.700}',
					color: '{primary.950}',
					focusColor: '#ffffff'
				}
			}
		}
    }
})

app.use(PrimeVue, {

	theme: {
		
		preset: MyPreset,
		options: {

			prefix: 'p',
			darkModeSelector: false || 'none',
			cssLayer: false
		}
	},
	ripple: true
});

// ==========| Google Login component |==========
app.use(vue3GoogleLogin, { clientId: process.env.VUE_APP_GOOGLE_AUTH_CLIENT_ID_WEB })

// ==========| Recaptcha |==========
app.use(VueReCaptcha, { siteKey: '6LfG0aggAAAAAPeK-jIOG07wKRzItYQU4QTtw6XA' })

// ==========| Google Analytics |==========
if ( process.env.VUE_APP_ENV === 'prod' ) {

	const gtm = createGtm({ id: "GTM-M4L3KPR", vueRouter: router })
	app.use(gtm)
}

InitApplication(app.config)
app.directive('ripple', Ripple)
app.directive('ptooltip', Tooltip)
app.directive('who', who)
app.directive('hscroll', hscroll)
app.directive('scrollto', scrollto)
app.directive('scroll-percent', scrollPercent)
app.directive('help-tooltip', helpTooltip)

app.mount('#app')